var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReplay = function SvgReplay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 42q-3.35 0-6.25-1.25t-5.075-3.425Q10.5 35.15 9.25 32.25 8 29.35 8 26h1.55q0 6 4.225 10.225T24 40.45q6 0 10.225-4.225T38.45 26q0-6-4.15-10.225T24.15 11.55h-1.2l3.55 3.5-1.1 1.05-5.4-5.45 5.45-5.4 1.1 1.05-3.7 3.7H24q3.35 0 6.25 1.25t5.075 3.425Q37.5 16.85 38.75 19.75 40 22.65 40 26t-1.25 6.25q-1.25 2.9-3.425 5.075Q33.15 39.5 30.25 40.75 27.35 42 24 42Z"
  })));
};
export default SvgReplay;